'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formDefinition", "fieldKey", "value", "rawHtmlEnabled", "onChange", "debouncedLoadOptions", "hasFormsWriteAccess", "onCreateClick", "onCloneClick", "onPagesClick", "onEditorClick", "onViewSubmissionsClick", "required"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFlex from 'UIComponents/layout/UIFlex';
import AsyncSelector from 'ContentComponents/cmv2/components/AsyncSelector';
import FormSaveIndicator from 'ContentComponents/cmv2/form/FormSaveIndicatorContainer';
import FormActionsDropdown from './FormActionsDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const inlineEditingI18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.${key}`;
const FormSelectorSelect = props => {
  const {
      formDefinition,
      fieldKey,
      value,
      rawHtmlEnabled,
      onChange,
      debouncedLoadOptions,
      hasFormsWriteAccess,
      onCreateClick,
      onCloneClick,
      onPagesClick,
      onEditorClick,
      onViewSubmissionsClick,
      required
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UIFormControl, {
    labelClassName: "p-right-0",
    label: /*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: inlineEditingI18nKey('formSelect.label')
      }), /*#__PURE__*/_jsx(FormSaveIndicator, {
        form: formDefinition
      })]
    }),
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(AsyncSelector, Object.assign({}, rest, {
        value: value,
        onChange: onChange,
        loadOptions: debouncedLoadOptions,
        "data-selenium": `${fieldKey}:formSelect`,
        clearable: !required
      })), !rawHtmlEnabled && formDefinition && /*#__PURE__*/_jsx(FormActionsDropdown, {
        guid: value,
        hasFormsWriteAccess: hasFormsWriteAccess,
        onCreateClick: onCreateClick,
        onCloneClick: onCloneClick,
        onPagesClick: onPagesClick,
        onEditorClick: onEditorClick,
        onViewSubmissionsClick: onViewSubmissionsClick
      })]
    })
  });
};
export default FormSelectorSelect;